import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Store, StoreCreate, StoreFilter } from '../data/store';

export function createStoreService(client: AxiosInstance) {
  return createCrudService<Store, StoreCreate, StoreFilter>(client, '/Store', 'storeId');
}

export type StoreService = CrudService<Store, StoreCreate, StoreFilter>;
